import * as style from './style.css';

import type * as React from 'react';
import { ReactNode } from 'react';

interface ILayoutCardProps {
  gallery: ReactNode;
  building: ReactNode;
  builder: ReactNode;
}

export const LayoutCardWrapper = ({ gallery, builder, building }: ILayoutCardProps): React.JSX.Element => {
  return (
    <div className={style['card']} data-testid="LayoutCard">
      <div className={style['gallery']}>{gallery}</div>
      <div className={style['building']}>{building}</div>
      <div className={style['builder']}>{builder}</div>
    </div>
  );
};
